import { render } from "./VueLoading.vue?vue&type=template&id=011c456b"
import script from "./VueLoading.vue?vue&type=script&lang=js"
export * from "./VueLoading.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__